"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;
var WARNED = [];

function deprecated(message) {
  if (WARNED.indexOf(message) === -1) {
    console.warn(message); // eslint-disable-line no-console
    WARNED.push(message);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-enhancements/lib/utils/deprecated.js
// module id = 187
// module chunks = 0